import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
const MatureStrictBlockedOverlay = (props)=>{
    const { t  } = useTranslation();
    const sfwbrowse = useFlag('sfwbrowse');
    if (sfwbrowse) {
        return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
            icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
                size: IconSize.HUGE
            }),
            text: t('deviationview.blocked.mature.text.sfwbrowse')
        }, props));
    }
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.mature.strict'),
        text: t('deviationview.blocked.mature.strict.text'),
        strict: true
    }, props));
};
MatureStrictBlockedOverlay.displayName = 'MatureStrictBlockedOverlay';
export default MatureStrictBlockedOverlay;
